import React, { useState, useEffect, useRef } from 'react';
import CustomImage from './CustomImage';
const WhenClosed = ({ open, settings, bubble }) => {
  const [showBubble, setShowBubble] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const bubbleColor = settings.color;
  const closeicon = 'https://flaticons.net/icon.php?slug_category=mobile-application&slug_icon=close';
  const bubbleCount = useRef(0);
  useEffect(() => {
    if (bubbleCount.current >= 2 || !bubble) return; 
    const bubbleTimer = setTimeout(() => {
      setShowBubble(bubble);
      if (bubble) {
        bubbleCount.current += 1;
        const closeButtonTimer = setTimeout(() => {
          setShowCloseButton(true);
        }, 250); 
        return () => clearTimeout(closeButtonTimer); 
      } else {
        setShowCloseButton(false);
      }
    }, 1000);
    return () => clearTimeout(bubbleTimer); 
  }, [bubble]); 

  const handleCloseBubble = () => {
    setShowBubble(false);
    setShowCloseButton(false);
  };

  return (
    <div
  style={{
    position: 'fixed',
    bottom: '25px',
    right: '20px',
    textAlign: 'center',
    zIndex: 1000,
  }}
    >
      <div
        style={{
          position: 'absolute',
          bottom: '100px',
          right: '10px',
          backgroundColor: bubbleColor,
          color: 'white',
          padding: '10px 15px',
          borderRadius: '20px',
          fontSize: '16px',
          width: '270px',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
          textAlign: 'left',
          opacity: showBubble ? 1 : 0,
          transform: showBubble ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
          fontFamily: 'Arial, sans-serif',
          boxShadow: `0px 6px 12px rgba(0, 0, 0, 0.3)`,
          zIndex: 1,
        }}
      >
        {settings.whenClosedMessage}
      </div>
      <button
        onClick={handleCloseBubble}
        style={{
          position: 'absolute',
          bottom: '190px',
          right: '11px',
          backgroundColor: bubbleColor,
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          padding: 0,
          borderRadius: '50%',
          zIndex: 2,
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: showCloseButton ? 1 : 0,
          transform: showCloseButton ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
          boxShadow: `0px 4px 8px rgba(0, 0, 0, 0.3)`,
        }}
      >
        <img src={closeicon} alt="Close" style={{ width: '12px', height: '12px' }} />
      </button>
      <button
        onClick={open}
        style={{
          position: 'absolute',
          bottom: '20px',
          right: '20px',
          outline: 'none',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0, 
        }}
      >
        <CustomImage color={settings.color} />
      </button>
    </div>
  );
};

export default WhenClosed;